import { ZONES_BASE_PATH } from '../constants';
import { getCurrentEcosystemBasePath } from './getCurrentEcosystemBasePath';

export function getCurrentZoneBasePath(currentPath = window.location.pathname): string | undefined {
  // Step 1: remove optional '/portal' prefix
  const pathWithoutPortal = currentPath.startsWith('/portal') ? currentPath.replace(/^\/portal/, '') : currentPath;

  // Step 2: detect ecosystem base path (e.g. '/innovation')
  const ecosystemBasePath = getCurrentEcosystemBasePath(pathWithoutPortal);

  // Step 3: strip ecosystem base path if present so we can match against zone paths
  const normalizedPath =
    ecosystemBasePath && pathWithoutPortal.startsWith(ecosystemBasePath)
      ? pathWithoutPortal.replace(ecosystemBasePath, '')
      : pathWithoutPortal;

  for (const [, path] of Object.entries(ZONES_BASE_PATH)) {
    if (normalizedPath.startsWith(path)) {
      return path; // Return the actual zone base path (e.g., '/smart-zone')
    }
  }

  return '';
}
